import clsx from 'clsx';
import { StatusDot } from '../template-card/components/StatusDot';
import { messageTemplateStatusLabel } from '../template-card/lib/messageTemplateStatusLabel';
import styles from './TemplateStatusBadge.module.css';

export function TemplateStatusBadge({ status, className }) {
  const label = messageTemplateStatusLabel(status);

  return (
    <div className={clsx(styles.badge, className)} aria-label={`Status: ${label}`}>
      <StatusDot status={status} />
      <span className={clsx(styles.label)}>{label}</span>
    </div>
  );
}
